import { NfzSettingsForm } from './form/NfzSettingsForm';
import { NfzSettingsFormLoader } from './form/NfzSettingsForm.loader';
import { NfzSettingsActionBar } from './NfzSettingsActionBar';

export const NfzSettingsPanel = (): JSX.Element => {
   return (
      <NfzSettingsActionBar>
         <NfzSettingsFormLoader>
            {({ ewusConfiguration, ezwmConfiguration, nfzConfiguration }) => (
               <NfzSettingsForm
                  ewusConfiguration={ewusConfiguration}
                  ezwmConfiguration={ezwmConfiguration}
                  nfzConfiguration={nfzConfiguration}
               />
            )}
         </NfzSettingsFormLoader>
      </NfzSettingsActionBar>
   );
};
